<main role="main" class="page-port-du-maroc not-home-page">
  <div class="container">
    <div class="row">
      <div class="col-md-12 index-up">
        <app-breadcrumb></app-breadcrumb>
        <h2 *ngIf="!archive" >{{"general.Actualites" | translate}}</h2>
        <h2 *ngIf="archive">{{"general.Archive" | translate}}</h2>
      </div>
    </div>
  </div>
  <div class="container" *ngIf="isclicked">
    <div class="row">
      <div class="col-md-3 side-bar">
        <div class="selected-item">      </div> 
        <nav id="sidebar">
          <app-statique-menu [lg]="outputLg" [cururl]="currentUrl"></app-statique-menu>
        </nav>
      </div>
      <div class="col-md-9" [innerHTML]="Corps"></div>
    </div>
  </div>
  <section *ngIf="!isclicked" class="container">
    <!-- <div class="row slickappel" data-aos="fade-up">
      <div *ngFor="let acts of dataActualite" class="col-md-12">
        <a *ngFor="let a of acts" routerLink="{{a.ID}}" class="block-appels d-flex align-items-start flex-column">
          <div class="d-flex justify-content-between w-100">
            <div class="num-appel-offre">{{a.Title}}</div>
            <div class="date-appels mt-auto">{{converteDate(a.AcualiteDate)}} </div>
          </div>
          <h3 class="titre-appels size18">{{getLine(a.ActualiteDescription)}}</h3>
        </a>
      </div>
    </div> -->
    <div class="row">
      <div class="col-md-3 side-bar">
        <div class="selected-item">      </div> 
        <nav id="sidebar">
          <app-statique-menu [lg]="outputLg" [cururl]="currentUrl"></app-statique-menu>
        </nav>
      </div>
      <div class="col-md-9">
        <table class="row slickappel" data-aos="fade-up" style="width: 100%;">
          <thead>
            <tr>
              <th style="min-width: 250px;"></th>
            </tr>
          </thead>
        </table>
      </div>
    </div>

  </section>
</main>